import React from 'react';
import Badge from '../../../components/shared/Badge';
import { TRUST_BADGES } from '../../../config/socialProof';

/**
 * TrustBadges Component
 * Displays grid of trust badges (Intuit Partner, SOC 2 Hosting, SSL, Support)
 */
const TrustBadges = () => {
    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '12px',
                marginTop: '24px',
            }}
        >
            {TRUST_BADGES.map(badge => (
                <Badge
                    key={badge.id}
                    icon={badge.icon}
                    label={badge.label}
                    variant="trust"
                    size="sm"
                />
            ))}
        </div>
    );
};

export default TrustBadges;
